import React, { useState } from 'react';
import CajaDiaria from './CajaDiaria';
import shared from './styles/adminShared.module.css';
import styles from './styles/CajasPanel.module.css';

export type MetodoCaja = 'Efectivo' | 'Transferencia' | 'Tarjetas' | 'QR';

/**
 * Unifica las cuatro cajas (antes cuatro entradas separadas del menu) en una
 * sola seccion con un selector general. Arranca en la primera opcion, sin
 * pedirle al usuario una seleccion manual previa.
 */
const METODOS: { value: MetodoCaja; label: string }[] = [
    { value: 'Efectivo', label: 'Efectivo' },
    { value: 'Transferencia', label: 'Transferencias' },
    { value: 'Tarjetas', label: 'Tarjetas (D/C)' },
    { value: 'QR', label: 'QR' },
];

const CajasPanel: React.FC = () => {
    const [metodo, setMetodo] = useState<MetodoCaja>(METODOS[0].value);

    return (
        <div>
            <div className={styles.toolbar}>
                <label className={styles.field} htmlFor="caja-metodo">
                    <span className={styles.label}>Metodo de pago</span>
                    <select
                        id="caja-metodo"
                        className={styles.select}
                        value={metodo}
                        onChange={e => setMetodo(e.target.value as MetodoCaja)}
                    >
                        {METODOS.map(m => (
                            <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                    </select>
                </label>

                {/* Acceso directo al resto de las cajas sin abrir el selector */}
                <div className={styles.tabs} role="tablist" aria-label="Metodo de caja">
                    {METODOS.map(m => (
                        <button
                            key={m.value}
                            type="button"
                            role="tab"
                            aria-selected={metodo === m.value}
                            className={`${shared.btn} ${shared.btnSmall} ${metodo === m.value ? shared.btnPrimary : shared.btnSecondary}`}
                            onClick={() => setMetodo(m.value)}
                        >
                            {m.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* key fuerza el remount para que la caja recargue con el metodo nuevo */}
            <CajaDiaria key={metodo} metodo={metodo} />
        </div>
    );
};

export default CajasPanel;
